// extracted by mini-css-extract-plugin
export default {"percentage-style":"performance-value_percentage-style__Y+9Th","row":"performance-value_row__wiDFo","min":"performance-value_min__BQmrO"};